module.exports = __webpack_public_path__ + "img/iniciar-curso.4b5fb091.webp";